export default __webpack_public_path__ + "static/media/servicetype_sheetmetal_192.08b7e5ba.png";